import { render, staticRenderFns } from "./LegInputFields.vue?vue&type=template&id=098558ae&scoped=true"
import script from "./LegInputFields.vue?vue&type=script&lang=js"
export * from "./LegInputFields.vue?vue&type=script&lang=js"
import style0 from "./LegInputFields.vue?vue&type=style&index=0&id=098558ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098558ae",
  null
  
)

export default component.exports